import {useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import SpinnerLoading from '../../../components/SpinnerLoading';
import Button from '../../../components/button';
import CustomHeader from '../../../components/mazraeKit/headers/homeHeader';
import NoItemFoundPage from '../../../components/noItemFoundPage';
import useGetOrderDetails from '../../../services/hookService/getOrderDetails/useGetOrderDetails';
import {useBlockBack} from '../../../utilities/hooks/useBackBlock/useBlockBack';
import LendTechPaySheet from '../../lendtech/components/Lendtechpaysheet/Lendtechpaysheet';
import InfoRow from '../ItemCard/InfoRow';
import {TransactionTypesChoices} from '../cash-payment/utils/helpers';
import OrderItem from './OrderItem';

const CheckOrder = () => {
  const navigate = useNavigate();
  const {orderGuid} = useParams();

  const [isPayFlowOpen, setIsPayFlowOpen] = useState(false);

  const {data, isLoading} = useGetOrderDetails({orderGuid});

  useBlockBack({redirectTo: '/home'});

  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center w-full bg-white h-dvh">
        <SpinnerLoading size={40} />
      </div>
    );
  }

  if (!data?.guid) {
    return (
      <div className="flex flex-col items-center justify-center w-full bg-white h-dvh">
        <NoItemFoundPage />
      </div>
    );
  }

  const storeOrders = data.store_order ?? [];
  const storeCounts = storeOrders.length;
  const areStoresDifferent = storeCounts > 1;

  const orderReceiveType = data.profile_address?.guid
    ? 'ارسال فروشنده'
    : 'دریافت حضوری';

  const storeAddress = data.profile_address?.building_number
    ? `${data.profile_address.delivery_address} پلاک ${data.profile_address.building_number}`
    : data.profile_address?.delivery_address ?? '';

  return (
    <div className="flex flex-col w-full bg-white h-dvh">
      <CustomHeader
        preComponent={() => (
          <div
            className="relative flex items-center gap-2"
            onClick={() => navigate('/my-account')}
          >
            <i className="icon-nameArrow---Right text-[25px] text-gray-700" />
            <span className="font-medium">خرید محصول</span>
          </div>
        )}
      />

      <div className="flex flex-col w-full h-full p-3 overflow-y-auto">
        <div className="flex flex-col h-full space-y-3">
          <span className="text-md">موارد سفارش</span>

          <div className="flex flex-col gap-3 mx-2 bg-zinc-100 rounded-2xl">
            {storeOrders.map(storeOrder =>
              storeOrder.order_items.map(order => (
                <OrderItem key={order.guid} order={order} />
              )),
            )}
          </div>

          <div className="pb-4 mt-4">
            <span className="text-sm">جزئیات تحویل</span>

            <InfoRow
              className="mt-3"
              label="نوع تحویل"
              value={orderReceiveType}
            />

            {data.profile_address?.delivery_address && (
              <>
                <div className="w-full h-[1px] bg-gray-200 my-3" />
                <InfoRow label="آدرس" value={storeAddress} />
              </>
            )}

            {data.profile_address?.postal_code && (
              <>
                <div className="w-full h-[1px] bg-gray-200 my-3" />
                <InfoRow
                  label="کد پستی"
                  value={data.profile_address.postal_code}
                />
              </>
            )}
          </div>

          {areStoresDifferent && (
            <div className="p-3 mt-auto text-justify text-orange-700 bg-amber-50 rounded-2xl text-md">
              موارد موجود در لیست از {storeCounts} فروشگاه انتخاب شده‌اند و
              بعنوان {storeCounts} سفارش ثبت می‌شوند. دقت بفرمایید ارسال محصولات
              از هر فروشگاه بصورت جداگانه و در زمان‌های مختلف انجام می‌شود.
            </div>
          )}
        </div>
      </div>

      <div className="w-full h-14 mb-4 flex px-4 bg-white shadow-[0px_-1px_6px_0px_rgba(0,_0,_0,_0.1)]">
        <Button
          className="w-full text-white rounded-lg !bg-[#518A15]"
          onClick={() => setIsPayFlowOpen(true)}
        >
          پرداخت {data?.total_price?.toLocaleString()} تومان
        </Button>
      </div>

      <LendTechPaySheet
        isOpen={isPayFlowOpen}
        setIsOpen={setIsPayFlowOpen}
        transactionType={TransactionTypesChoices.ORDER}
        orderGuid={orderGuid}
      />
    </div>
  );
};

export default CheckOrder;
